export default __webpack_public_path__ + "static/media/62.ac0cd13a.png";